// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"AuthenticatedSidebar_sidebar__1MY32","dimmer":"AuthenticatedSidebar_dimmer__29eTM","mobileSidebarOpen":"AuthenticatedSidebar_mobileSidebarOpen__3p-Ja"};